import React from "react";

import copy_to_clipboard_icon from "assets/images/icons/copy_to_clipboard_icon.png";

import { Button } from "@chakra-ui/react";

export default function CopyToClipboard(props) {
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <Button
      variant="ghost"
      onClick={() => (props.text ? copyToClipboard(props.text) : <></>)}
    >
      <div className="flex flex-row gap-2 ">
        <div className="h-[20px] w-[20px] ">
          <img className="" src={copy_to_clipboard_icon} />
        </div>
        <p className="secondary-text ">Copy to Clipboard</p>
      </div>
    </Button>
  );
}
